// Tiny sounds for the Sales tab, made with WebAudio so there is nothing to
// load. Off by default on a device until the rep turns them on (browsers
// will not play audio before the first tap anyway). Never throws.
const KEY = 'sales.sound';

export const soundOn = () => { try { return window.localStorage.getItem(KEY) === '1'; } catch { return false; } };
export const setSoundOn = (on) => { try { if (on) window.localStorage.setItem(KEY, '1'); else window.localStorage.removeItem(KEY); } catch { /* ignore */ } };

let ctx = null;
const audio = () => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
  } catch { return null; }
};

const tone = (ac, freq, at, dur, gain = 0.08, type = 'sine') => {
  const o = ac.createOscillator();
  const g = ac.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, at);
  g.gain.setValueAtTime(0.0001, at);
  g.gain.exponentialRampToValueAtTime(gain, at + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  o.connect(g).connect(ac.destination);
  o.start(at);
  o.stop(at + dur + 0.02);
};

/**
 * 'tick'   a point scored (short, quiet)
 * 'win'    a demo, pilot or customer (three rising notes)
 * 'team'   a teammate's win (two notes)
 * 'reply'  a store wrote back (a soft double)
 * 'bell'   a sprint ended
 */
export function chime(kind = 'tick', { force = false } = {}) {
  if (!force && !soundOn()) return;
  const ac = audio();
  if (!ac) return;
  const t = ac.currentTime;
  switch (kind) {
    case 'win': tone(ac, 523, t, 0.12); tone(ac, 659, t + 0.12, 0.12); tone(ac, 784, t + 0.24, 0.3, 0.1); break;
    case 'team': tone(ac, 659, t, 0.1); tone(ac, 880, t + 0.11, 0.22); break;
    case 'reply': tone(ac, 740, t, 0.09, 0.06); tone(ac, 740, t + 0.16, 0.14, 0.06); break;
    case 'bell': tone(ac, 988, t, 0.4, 0.09, 'triangle'); tone(ac, 1319, t + 0.05, 0.6, 0.06, 'triangle'); break;
    default: tone(ac, 880, t, 0.06, 0.04); break;
  }
}
